export default function() {

	const accordions = document.getElementsByClassName('block-accordion');
	for (const accordion of accordions) {

		const accordionItems = accordion.getElementsByClassName('block-accordion-item');

		for (const accordionItem of accordionItems) {

			setUpAccordionItem(accordionItem);

			const accordionHeader = accordionItem.querySelector('.block-accordion-item__top');
			accordionHeader.addEventListener('click', (event) => {
				handleAccordionItems(accordionItem, accordionItems);
			});

			accordionHeader.addEventListener('keydown', (event) => {
				if (event.code === 'Enter' || event.code === 'Space') {
					event.preventDefault();
					handleAccordionItems(accordionItem, accordionItems);
				}
			});
		}
	}


	/**
	 * Add various attributes to the accordion item for accessibility and other purposes
	 *
	 * @param {HTMLElement} accordionItem - The accordion item being interacted with
	 */
	function setUpAccordionItem(accordionItem) {
		const baseID = accordionItem.getAttribute('data-accordion-item-id');
		const accordionItemHeader = accordionItem.querySelector('.block-accordion-item__top');
		const accordionItemContent = accordionItem.querySelector('.block-accordion-item__bottom');

		accordionItemHeader.setAttribute('tabindex', '0');
		accordionItemHeader.setAttribute('id', `block-accordion-item__top-${baseID}`);
		accordionItemHeader.setAttribute('aria-controls', `block-accordion-item__bottom-${baseID}`);
		accordionItemHeader.setAttribute('role', 'button');
		accordionItemHeader.setAttribute('aria-expanded', 'false');

		accordionItemContent.setAttribute('id', `block-accordion-item__bottom-${baseID}`);
		accordionItemContent.setAttribute('aria-hidden', 'true');
		accordionItemContent.querySelectorAll('*').forEach((element) => {
			element.setAttribute('tabindex', '-1');
		});
	}


	/**
	 * Handle logic for the state of accordion items in the accordion
	 *
	 * @param {HTMLElement} accordionItem - The accordion item being interacted with
	 * @param {HTMLCollection} accordionItems - The collection of accordion items within an accordion
	 */
	function handleAccordionItems(accordionItem, accordionItems) {
		// This accordion item is not open, so close everything and then open this one
		if (!accordionItem.classList.contains('open')) {
			closeAccordionItems(accordionItems);
			openAccordionItem(accordionItem);
		} else {
			// This accordion item is already open, so close everything
			closeAccordionItems(accordionItems);
		}
	}

	/**
	 * Close all of the accordion items in the accordion
	 *
	 * @param {HTMLCollection} accordionItems - The collection of accordion items within an accordion
	 */
	function closeAccordionItems(accordionItems) {

		for (const accordionItem of accordionItems) {
			const accordionItemContent = accordionItem.querySelector('.block-accordion-item__bottom');
			const accordionItemHeader = accordionItem.querySelector('.block-accordion-item__top');

			// Styling
			accordionItemContent.style.paddingTop = null;
			accordionItemContent.style.paddingBottom = null;
			accordionItemContent.style.maxHeight = null;
			accordionItem.classList.remove('open');

			// Accessibility
			accordionItemContent.setAttribute('aria-hidden', 'true');
			accordionItemHeader.setAttribute('aria-expanded', 'false');
			accordionItemContent.querySelectorAll('*').forEach((element) => {
				element.setAttribute('tabindex', '-1');
			});
		}
	}

	/**
	 * Open an accordion item
	 *
	 * @param {HTMLElement} accordionItem - The accordion item being interacted with
	 */
	function openAccordionItem(accordionItem) {
		const paddingTop = 50;
		const paddingBottom = 50;

		const accordionItemContent = accordionItem.querySelector('.block-accordion-item__bottom');
		const accordionItemHeader = accordionItem.querySelector('.block-accordion-item__top');

		// Styling
		accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight + paddingTop + paddingBottom}px`;
		accordionItemContent.style.paddingTop = `${paddingTop}px`;
		accordionItemContent.style.paddingBottom = `${paddingBottom}px`;
			accordionItem.classList.add('open');			
		

		// Accessibility
		accordionItemContent.setAttribute('aria-hidden', 'false');
		accordionItemHeader.setAttribute('aria-expanded', 'true');
		accordionItemContent.querySelectorAll('*').forEach((element) => {
			element.removeAttribute('tabindex');
		});
	}
}